import { Component, OnInit } from '@angular/core';
import { DeviceDetectService } from '@app/core/services/device-detect/device-detect.service';
import { NavDataService } from '@app/core/services/nav-data/nav-data.service';

@Component({
  selector: 'app-instructor-dashboard',
  templateUrl: './instructor-dashboard.component.html',
  styleUrls: ['./instructor-dashboard.component.scss'],
})
export class InstructorDashboardComponent implements OnInit {
  profiles = [
    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: 'assets/images/blank-profile.png',
      affiliation_status: 0,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },
    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: 'assets/images/blank-profile.png',
      affiliation_status: 0,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },
    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: 'assets/images/blank-profile.png',
      affiliation_status: 1,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },
    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: 'assets/images/blank-profile.png',
      affiliation_status: 0,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },
    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: '',
      affiliation_status: 0,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },

    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: 'assets/images/blank-profile.png',
      affiliation_status: 1,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },

    {
      uid: '1',
      first_name: 'Damien',
      last_name: 'Calvignac',
      profile_image: 'assets/images/blank-profile.png',
      affiliation_status: 0,
      affiliation_date: '20 Jan 2020',
      upgradation_date: '25 Jan 2020',
    },
  ];

  constructor(
    public deviceDetectService: DeviceDetectService,
    public navDataService: NavDataService
  ) {}

  ngOnInit() {
    this.navDataService.setPageTitle({ title: 'Referral Program' });
  }
}
